import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorisationService } from './services/auth/authorisation.service';
import { Functionalities } from './services/auth/functionalities';
import { LocalStorage } from './storage.class';

@Injectable()
export class IsNotAuthenticated {
    constructor(private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (LocalStorage.getUserToken() && AuthorisationService.hasFunctionality(Functionalities.PlanningOverview)) {
            this.router.navigate(['']);
        } else if (LocalStorage.getUserToken()) {
            this.router.navigate(['/weekschedule']);
        }
        return true;
    }
}
